import CemEmbed from './cem-embed';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import {Store, Vuetify} from '@/shared';
import './embed.scss';

const addContainerCustomElement = () => {
  Vue.use(vueCustomElement);

  Vue.customElement('cem-embed', {
    ...CemEmbed,
    store: Store,
    vuetify: Vuetify,
  });
};

export default {addContainerCustomElement};
